import { render, staticRenderFns } from "./product-label.vue?vue&type=template&id=86a980ae&"
import script from "./product-label.vue?vue&type=script&lang=js&"
export * from "./product-label.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports